import {SET_POST} from './types';

const initialState = {
  post: {
    detail: {},
    list: [],
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_POST:
      return {
        ...state,
        post: {...state.post, ...action.payload},
      };

    default:
      return state;
  }
}
export default reducer;
